const adminUserKeys = {
  all: ['ADMIN_USER'],
  userList: ({ currDiv }) => [...adminUserKeys.all, 'USER_LIST', currDiv],
  groupAuthList: () => [...adminUserKeys?.all, 'GROUP_AUTH_LIST'],
  user: ({ id }) => [...adminUserKeys?.all, 'USER', id],
};

export default adminUserKeys;
